import { useEffect, useState } from "react";
import "./App.css";
import ChatUI from "./chat";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 0,
      },
    },
  });
  const [theme, setTheme] = useState(false)
  useEffect(() => {
    const savedTheme = localStorage.getItem("isDarkMode");
    setTheme( savedTheme ? JSON.parse(savedTheme) : false);
  }, [])
  
  
  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        theme={!theme?"light":"dark"}
      />
      <div className="h-screen">
      <RouterProvider router={router} />
        {/* <ChatUI /> */}
      </div>
    </QueryClientProvider>
  );
}

export default App;
